import { IconAdd } from './add'
import { IconArrowForward } from './arrow-forward'
import { IconCalendar } from './calendar'
import { IconCandleBarBasic } from './candle-bar-basic'
import { IconCandleBarHeikinAshi } from './candle-bar-heikin-ashi'
import { IconCandleBarHollow } from './candle-bar-hollow'
import { IconCaretDown } from './caret-down'
import { IconCaretRight } from './caret-right'
import { IconCaretVertical } from './caretVertical'
import { IconChartBar } from './chart-bar'
import { IconChartBubble } from './chart-bubble'
import { IconChartPie } from './chart-pie'
import { IconChartTable } from './chart-table'
import { IconChartTreemap } from './chart-treemap'
import { IconChevronDown } from './chevron-down'
import { IconChevronRight } from './chevron-right'
import { IconClose } from './close'
import { IconDarkMode } from './dark-mode'
import { IconDiamondOutlined } from './diamond-outlined'
import { IconDone } from './done'
import { IconDraw } from './draw'
import { IconDrawingActionDelete } from './drawing-action-delete'
import { IconDrawingSettingAutosaveOff } from './drawing-setting-autosave-off'
import { IconDrawingSettingAutosaveOn } from './drawing-setting-autosave-on'
import { IconDrawingSettingAutosaveSaving } from './drawing-setting-autosave-saving'
import { IconDrawingSettingDrawingMode } from './drawing-setting-drawing-mode'
import { IconDrawingSettingDrawingModeActive } from './drawing-setting-drawing-mode-active'
import { IconDrawingSettingHide } from './drawing-setting-hide'
import { IconDrawingSettingLock } from './drawing-setting-lock'
import { IconDrawingSettingPreserveDrawings } from './drawing-setting-preserve-drawings'
import { IconDrawingSettingPreserveDrawingsActive } from './drawing-setting-preserve-drawings-active'
import { IconDrawingSettingShow } from './drawing-setting-show'
import { IconDrawingSettingUnlock } from './drawing-setting-unlock'
import { IconExitFullscreen } from './exit-fullscreen'
import { IconFlash } from './flash'
import { IconFullscreen } from './fullscreen'
import { IconGesture } from './gesture'
import { IconGift } from './gift'
import { IconHamburger } from './hamburger'
import { IconHelp } from './help'
import { IconIdea } from './idea'
import { IconIdeaLoad } from './idea-load'
import { IconIdeaSave } from './idea-save'
import { IconInterval } from './interval'
import { IconLayout1h1v } from './layout-1h1v'
import { IconLayout1h2v } from './layout-1h2v'
import { IconLayout1h3v } from './layout-1h3v'
import { IconLayout1l2r } from './layout-1l2r'
import { IconLayout1t2b } from './layout-1t2b'
import { IconLayout2h1v } from './layout-2h1v'
import { IconLayout2h2v } from './layout-2h2v'
import { IconLayout3h1v } from './layout-3h1v'
import { IconLayout3h2v } from './layout-3h2v'
import { IconLightMode } from './light-mode'
import { IconLineChartType } from './line-chart-type'
import { IconMenuClose } from './menu-close'
import { IconMinus } from './minus'
import { IconMore } from './more'
import { IconNote } from './note'
import { IconOhlcChartType } from './ohlc-chart-type'
import { IconPalette } from './palette'
import { IconProfile } from './profile'
import { IconPublish } from './publish'
import { IconRefresh } from './refresh'
import { IconRemove } from './remove'
import { IconRestore } from './restore'
import { IconSearch } from './search'
import { IconSettings } from './settings'
import { IconSettingsWheel } from './settings-wheel'
import { IconShare } from './share'
import { IconSignOut } from './sign-out'
import { IconStar } from './star'
import { IconStarOutlined } from './star-outlined'
import { SVG, SVGProps } from './svg'
import { IconSwitchHorizontal } from './switch-horizontal'
import { IconSwitchVertical } from './switch-vertical'
import { IconTabKey } from './tab-key'
import { IconTemplate } from './template'
import { IconToolArrow } from './tool-arrow'
import { IconToolBrush } from './tool-brush'
import { IconToolCallout } from './tool-callout'
import { IconToolCurve } from './tool-curve'
import { IconToolElliottWave } from './tool-elliott-wave'
import { IconToolEllipse } from './tool-ellipse'
import { IconToolExpand } from './tool-expand'
import { IconToolFibonacci } from './tool-fibonacci'
import { IconToolLine } from './tool-line'
import { IconToolMeasure } from './tool-measure'
import { IconToolMidlineH } from './tool-midline-h'
import { IconToolMidlineV } from './tool-midline-v'
import { IconToolMouse } from './tool-mouse'
import { IconToolPitchFork } from './tool-pitchfork'
import { IconToolPolygon } from './tool-polygon'
import { IconToolPosition } from './tool-position'
import { IconToolRect } from './tool-rect'
import { IconToolRectRotated } from './tool-rect-rotated'
import { IconToolText } from './tool-text'
import { IconToolTriangle } from './tool-triangle'
import { IconToolXABCD } from './tool-xabcd'
import { IconTrashCan } from './trash-can'
import { IconTrendingDown } from './trending-down'
import { IconTrendingUp } from './trending-up'
import { IconTriangle } from './triangle'
import { IconTriangleOutlineDown } from './triangle-outline-down'
import { IconTriangleOutlineUp } from './triangle-outline-up'
import { IconWarning } from './warning'

// Export the Icon component itself
export * from './icon'

export function isValidIconName(name?: unknown): name is IconNameType {
  if (!name || typeof name !== 'string') return false

  return !!iconList[name as IconNameType]
}

export type IconNameType = keyof typeof iconList

// Export list of icon components
export const iconList = {
  add: IconAdd,
  calendar: IconCalendar,
  candleBarBasic: IconCandleBarBasic,
  candleBarHeikinAshi: IconCandleBarHeikinAshi,
  candleBarHollow: IconCandleBarHollow,
  caretDown: IconCaretDown,
  caretRight: IconCaretRight,
  caretVertical: IconCaretVertical,
  chartBar: IconChartBar,
  chartBubble: IconChartBubble,
  chartPie: IconChartPie,
  chartTable: IconChartTable,
  chartTreemap: IconChartTreemap,
  chevronDown: IconChevronDown,
  chevronRight: IconChevronRight,
  close: IconMenuClose,
  darkMode: IconDarkMode,
  diamondOutlined: IconDiamondOutlined,
  done: IconDone,
  draw: IconDraw,
  drawingActionDelete: IconDrawingActionDelete,
  drawingSettingAutosaveOff: IconDrawingSettingAutosaveOff,
  drawingSettingAutosaveOn: IconDrawingSettingAutosaveOn,
  drawingSettingAutosaveSaving: IconDrawingSettingAutosaveSaving,
  drawingSettingDrawingMode: IconDrawingSettingDrawingMode,
  drawingSettingDrawingModeActive: IconDrawingSettingDrawingModeActive,
  drawingSettingHide: IconDrawingSettingHide,
  drawingSettingLock: IconDrawingSettingLock,
  drawingSettingPreserveDrawings: IconDrawingSettingPreserveDrawings,
  drawingSettingPreserveDrawingsActive: IconDrawingSettingPreserveDrawingsActive,
  drawingSettingShow: IconDrawingSettingShow,
  drawingSettingUnlock: IconDrawingSettingUnlock,
  empty: (props: SVGProps) => <SVG {...props} />,
  exitFullscreen: IconExitFullscreen,
  flash: IconFlash,
  fullscreen: IconFullscreen,
  gift: IconGift,
  hamburger: IconHamburger,
  help: IconHelp,
  idea: IconIdea,
  ideaLoad: IconIdeaLoad,
  ideaSave: IconIdeaSave,
  interval: IconInterval,
  layout1h1v: IconLayout1h1v,
  layout1h2v: IconLayout1h2v,
  layout1h3v: IconLayout1h3v,
  layout1l2r: IconLayout1l2r,
  layout1t2b: IconLayout1t2b,
  layout2h1v: IconLayout2h1v,
  layout2h2v: IconLayout2h2v,
  layout3h1v: IconLayout3h1v,
  layout3h2v: IconLayout3h2v,
  lightMode: IconLightMode,
  lineChartType: IconLineChartType,
  minus: IconMinus,
  menuClose: IconClose,
  more: IconMore,
  note: IconNote,
  ohlcChartType: IconOhlcChartType,
  profile: IconProfile,
  publish: IconPublish,
  refresh: IconRefresh,
  remove: IconRemove,
  restore: IconRestore,
  settingsWheel: IconSettingsWheel,
  gesture: IconGesture,
  search: IconSearch,
  settings: IconSettings,
  share: IconShare,
  signOut: IconSignOut,
  switchHorizontal: IconSwitchHorizontal,
  switchVertical: IconSwitchVertical,
  tabKey: IconTabKey,
  template: IconTemplate,
  toolArrow: IconToolArrow,
  toolBrush: IconToolBrush,
  toolCallout: IconToolCallout,
  toolCurve: IconToolCurve,
  toolElliottWave: IconToolElliottWave,
  toolEllipse: IconToolEllipse,
  toolExpand: IconToolExpand,
  toolFibonacci: IconToolFibonacci,
  toolLine: IconToolLine,
  toolMeasure: IconToolMeasure,
  toolMidLineH: IconToolMidlineH,
  toolMidLineV: IconToolMidlineV,
  toolMouse: IconToolMouse,
  toolPitchfork: IconToolPitchFork,
  toolPolygon: IconToolPolygon,
  toolPosition: IconToolPosition,
  toolRect: IconToolRect,
  toolRectRotated: IconToolRectRotated,
  toolText: IconToolText,
  toolTriangle: IconToolTriangle,
  toolXABCD: IconToolXABCD,
  triangle: IconTriangle,
  triangleOutlineDown: IconTriangleOutlineDown,
  triangleOutlineUp: IconTriangleOutlineUp,
  warning: IconWarning,
  palette: IconPalette,
  arrowForward: IconArrowForward,
  trendingUp: IconTrendingUp,
  trendingDown: IconTrendingDown,
  trashCan: IconTrashCan,
  star: IconStar,
  starOutlined: IconStarOutlined,
}
